import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '@bwoty-web/ui-kit';
import { UI_ARROW_RIGHT, UI_PHOTO_NARROW } from '@bwoty-web/ui-kit/icons';

import './galleryButton.scss';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

const GalleryButton = ({ text, onClick, className }) => {
  const isGlobe = useIsGlobetrotter();
  const RenderType = onClick ? 'button' : 'div';

  return (
      <RenderType
        type={onClick ? 'button' : undefined}
        className={cx('gw-gallery-button', className)}
        onClick={onClick}
        aria-hidden={onClick ? 'false' : 'true'}
      >
        {!isGlobe && <Icon path={UI_PHOTO_NARROW} size="xs" sizeMobile="xs" />}
        <span>{text}</span>
        {!isGlobe && <Icon size="xs" sizeMobile="xs" path={UI_ARROW_RIGHT} />}
      </RenderType>
  );
};

GalleryButton.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

GalleryButton.defaultProps = {
  onClick: null,
  className: null,
};

export default GalleryButton;
